import { useRouter as l } from "next/router.js";
import { usePathname as m, useSearchParams as o } from "next/navigation.js";
const i = (a, { isSub: n = !1 } = {}) => {
  const c = m(), u = l(), s = o(), t = n ? "subtab" : "tab";
  return { activeTab: a.find(
    (r) => r.value === s.get(t)
  ) ? s.get(t) : a[0].value, handleChange: (r) => {
    const e = new URLSearchParams(s.toString());
    if (r === a[0].value ? e.delete(t) : e.set(t, r), n || e.delete("subtab"), !e.size) return u.replace(c);
    u.replace(`${c}?${e}`);
  }, options: a };
};
export {
  i as default
};
